/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Admin grant of one extra exam attempt. Repeatable; each call adds one.
 */
export interface GrantExamAttemptRequest {
  /** @minLength 1 */
  note: string;
  /** @minLength 1 */
  clientRequestId: string;
}
